<template lang="pug">
  div.footer.footer-background-white.ios-navbar
    div.footer-img

      div.img(@click="routeMainPage()")
        nav-bar-button(
          :img="'home.svg'"
          :whiteImg="'home-white.svg'"
          namePage= 'MainPage'
        )

      div.img(@click="routeGoalPage()")
        nav-bar-button(
          :img="'goal.svg'"
          :whiteImg="'goal-white.svg'"
          namePage='GoalPage'
        )

      div.img(@click="routeProfilePage()")
        nav-bar-button(
          :img="'profile.svg'"
          :whiteImg="'profile-white.svg'"
          namePage='ProfilePage'
        )

      div.img(@click="routeGpsPage()")
        nav-bar-button(
          :img="'gps.svg'"
          :whiteImg="'gps-white.svg'"
          namePage='GpsPage'
        )

</template>

<script>
import NavBarButton from './NavBarButton.vue';

export default {
  name:"NavBar",

  components: {
    NavBarButton
  },

  methods: {
    routeMainPage() {
      this.$router.push({path:"/home"})
    },

    routeGoalPage() {
      this.$router.push({path:"/goalPage"})
    },

    routeProfilePage() {
      this.$router.push({path:"/profilePage"})
    },

    routeGpsPage() {
      this.$router.push({path:"/GpsPage"})
    },

  }

}
</script>

<style scoped>
.footer {
  position: fixed;
  box-shadow: 0px -0.1px 2px rgba(128, 128, 128, 0.452);
  z-index: 202;
  border-radius: 20px;
  bottom: 10px;
  width: 242px;
  height: 56px;
  display: flex;
  align-items: center;
  box-shadow: 0px 25px 50px 0px #00000040;
  border: 1px solid #E5E7EB;
}
.footer-background-white{
  background: #FFFFFF;
}
.footer-img {
  display: flex;
  padding: 8px 16px 8px 16px;
  justify-content: center;
}
.img {
  position: relative;
}
.ios-navbar {
  height: 64px;
}
</style>
